import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateFn } from '@angular/router';
import { PagesAvailableService } from 'src/app/pages/pages-available.service';
import { AppCacheStorageService } from '../services/storage/app-cache-storage.service';
import { GTMService } from '../services/GoogleTagManager/googleTagManager.service';


@Injectable({
  providedIn: 'root'
})
class PermissionsService {
  constructor(private readonly pagesService: PagesAvailableService,private readonly cache: AppCacheStorageService,private readonly googleTagManagerService: GTMService) {
  }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    // TODO check if current page is allowed for client
    /* Load cache and get feedier object and then push it to tag manager service */
    /*this.cache.load('feedier').then((data) => {
      if(data){
        console.log(this.googleTagManagerService);
        this.googleTagManagerService.feedier(data);
      }
    });*/
    
    return true;
  }
}

export const PageAccessGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean => {
  return inject(PermissionsService).canActivate(next, state);
}
